import ReactMarkdown from 'react-markdown';

import { Wrapper } from '@american-autonomy/ag-ui';

import { REMARK_PLUGINS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LegalPage: FunctionComponent<Props> = ({ content, testId = TEST_ID }) => (
    <Wrapper className={styles.page} testId={testId}>
        <article className={styles.article}>
            <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{content}</ReactMarkdown>
        </article>
    </Wrapper>
);

export default LegalPage;
